export default __webpack_public_path__ + "static/media/pictogramBeaconMicrophone48.7802e97d.svg";